<nav class="navbar bc-title-navbar">
  <h1 class="d-none d-sm-block">Administrador de Ambientes</h1>
  <div class="ml-auto">
    <button class="btn btn-primary" (click)="login()"><h5>Ingresar</h5></button>
  </div>
</nav>
